import React, {Fragment, memo} from 'react';
import {CSSTransition} from 'react-transition-group';

import ArrowLeft from '../images/arrow_left.svg';

import {styleMods} from '../utils';

import style from './hidable-box.module.scss';

const HidableBox = memo(
	/**
	 * @param {{
	 *   visible: boolean,
	 *   toggleVisible?: () => void,
	 *   header?: React.ReactNode,
	 *   children?: React.ReactNode,
	 * }} props
	 * @returns {React.ReactElement} ...
	 */
	function HidableBox({visible, toggleVisible, header, children}) {
		const clickable = !!toggleVisible;

		return (
			<Fragment>
				<header
					className={styleMods(style, 'header', {visible, clickable})}
					onClick={toggleVisible}
					role={clickable ? 'checkbox' : undefined}
					tabIndex={clickable ? 0 : undefined}
				>
					<div className={style.headerContent}>
						{header}
					</div>
					<ArrowLeft className={style.openArrow} />
				</header>

				<div className={style.contentWrapper}>
					<CSSTransition
						in={visible}
						timeout={{
							enter: 300,
							exit: 300,
						}}
						classNames={{
							enter: style.contentEnter,
							enterActive: style.contentEnterActive,
							enterDone: style.contentEnterDone,
							exit: style.contentExit,
							exitActive: style.contentExitActive,
						}}
					>
						<div className={style.content}>
							{children}
						</div>
					</CSSTransition>
				</div>
			</Fragment>
		);
	}
);
export default HidableBox;
